import { Type } from 'class-transformer';
import { BaseEntity } from '@models';
import { Organization } from '@services/organization';
import { CarModel } from '@services/car-model';

export class SimulationVehicle extends BaseEntity {
	organizationId: string;

	@Type(() => Organization)
	organization: Organization;

	simulationTaskId: string;

	// @Type(() => SimulationTask)
	// simulationTask: SimulationTask;

	carModelId: number;

	@Type(() => CarModel)
	carModel: CarModel;

	stockId: string;
	proposed: boolean;
	notInSuggestedList: boolean;
	fromStock: boolean;
	stockPrice: number;
	fuelCost: number;
	co2emission: number;
	totalCostOfOwnership: number;
}
